export default __webpack_public_path__ + "laravel.1f4e3ad9.png";